import React from 'react';
import styles from '../SaleReportPage.module.scss';

function InputSuffix({ value, unit, placeholder, readOnly, onChange }) {
  return (
    <div className={styles.inputSuffix}>
      <input
        type="text"
        className={styles.input}
        value={value != null ? value : ''}
        placeholder={placeholder}
        readOnly={readOnly}
        onChange={onChange ? (e) => onChange(e.target.value) : undefined}
        inputMode="decimal"
      />
      <span className={styles.unit}>{unit}</span>
    </div>
  );
}

export default InputSuffix;
